module.exports = __webpack_public_path__ + "img/prescription-bottle-alt.9a917b51.svg";